import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Icon } from '@panel/commons';
import success from '@panel/commons/assets/img/success.svg';
import { useQuery } from '@panel/commons/hooks';
import { SuccessContainer, NumberContact } from '../../styles';
import { updateLastStep } from '../../../../../ducks/stepper';
import { selectCurrentProduct, selectEcommerceUser, selectProductTaxesParams } from '../../../../../ducks/step4Module2';
import { sendPaymentNotification } from '../../../../../utils';
import { usePublisherRedirection } from '../../../../../hooks/usePublisherRedirection';
import { Step1Module4Selectors } from '../../../../../ducks/step1Module4';

function ContactSuccess() {
  const { id: userId, firstName, lastName, email } = useSelector(selectEcommerceUser);
  const { productId } = useSelector(selectProductTaxesParams);
  const { fullTitle: planTitle } = useSelector(selectCurrentProduct);
  const { formValues } = useSelector(Step1Module4Selectors.getStep1Module4State);
  const [postingId] = useQuery(useLocation(), ['postingId']);
  const { state } = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  usePublisherRedirection(!productId, '/planes/seleccion');

  useEffect(() => {
    dispatch(updateLastStep('4', '2'));
    async function sendMail() {
      const { phoneNumber } = state;
      const mailData = {
        userName: `${firstName} ${lastName}`,
        userPhoneNumber: phoneNumber,
        userEmailAddress: email,
        planDescription: planTitle,
        postingId,
        postingTitle: formValues.title
      };
      await sendPaymentNotification('CONTACT', mailData);
    }
    if (state) {
      sendMail();
    }
  }, [dispatch, userId, postingId, state, planTitle, firstName, lastName, email, formValues.title]);

  return (
    <SuccessContainer>
      <img src={success} alt='contactSuccess' />
      <h3>{t('publisher.step4.module2.contactSuccess.title')}</h3>
      <div>
        <p>{t('publisher.step4.module2.contactSuccess.message')}</p>
        <p>{t('publisher.step4.module2.contactSuccess.message2')}</p>
      </div>
      <NumberContact>
        <Icon name='callphone' />
        {t('publisher.step4.module2.contactSuccess.phoneNumber1')}
      </NumberContact>
    </SuccessContainer>
  );
}

export default ContactSuccess;
